module.exports = __webpack_public_path__ + "img/pic_xifashui1.c24d6c3e.png";